import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * order endpoints
 */
export const fetchOrders = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/orders', q, page, perPage, sortOpts, extraParams);

export const fetchOrder = (orderId) => request.fetchDetail(`/orders/${orderId}`);

export const createOrder = (payload) =>
  request.postJSON(
    '/orders',
    excludeObjNullValue({
      name: payload.name,
      subscriptions: parseInt(payload.subscriptions),
      school_id: payload.schoolId,
      expiry_date: payload.expiryDate,
    }),
  );

export const updateOrder = (payload) =>
  request.putJSON(
    `/orders/${payload.orderId}`,
    excludeObjNullValue({
      name: payload.name,
      subscriptions: parseInt(payload.subscriptions),
      school_id: payload.schoolId,
      expiry_date: payload.expiryDate,
    }),
  );

export const deleteOrder = (orderId) => request.deleteReq(`/orders/${orderId}`);
